module.exports = __webpack_public_path__ + "img/fast-delivery-alt.8bce11a.svg";